import styled from 'styled-components';
import { getFont } from '@finect/tabular-utils/getFont';
export var CardTitle = styled.a.withConfig({
  displayName: "CardTitle",
  componentId: "sc-19ksc9m-0"
})(["display:flex;align-items:center;", ";font-weight:600;color:currentColor;&:hover{color:", ";}span{margin-left:4px;}"], getFont(0, 'compact'), function (_ref) {
  var theme = _ref.theme,
    withLink = _ref.withLink;
  return withLink ? theme.linkColor : theme.colors.font;
});